import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import { ErrorMsg } from "../../constants/errormessages.constant";
import ModalExitAlertStyle from "../../styles/modalExitAlertStyle";

class ModalExitAlert extends React.Component {
    render() {
        const {
            classes,
            modalOpen,
            closeModal,
            onConfirmation,
            type,
            typos = {
                confirmationMessage: 'Are you sure you want to cancel? All inputs will be lost.',
                confirmButtonLabel: 'Yes, cancel',
                closeButtonLabel: 'No, do not'
            }
        } = this.props;
        let style = modalOpen ? { bottom: 0 } : { bottom: -170 };
        let children = null;
        if (type === "confirmation") {
            children = ([<div key="header" className={classes.modalHeader}>Confirmation</div>,
            <div id="confirmation-modal" key="body" data-view="exit-modal-component-wrapper" className={classes.modalBody}>
                <div className={classes.contentWrapper}>
                    {typos.confirmationMessage}
                </div>
                <div className={classes.modalActionWrapper}>
                    <Button
                        tabIndex={modalOpen ? 0 : -1}
                        onClick={onConfirmation}
                        variant="contained"
                        id="submit-button"
                        color="primary"
                        className={classes.buttonStyle}
                    >
                        {typos.confirmButtonLabel}
                    </Button>
                    <Button
                        tabIndex={modalOpen ? 0 : -1}
                        onClick={closeModal}
                        id="close-button"
                        variant="contained" color="primary"
                        className={classes.cancelButtonStyle}
                    >
                        {typos.closeButtonLabel}
                    </Button>
                </div>
            </div>])
        }
        else if (type === "alert" && modalOpen === true) {
            children = ([<div key="header" className={`${classes.modalHeader} ${classes.modalAlertHeader}`}>ALERT</div>,
            <div id="alert-modal" key="body" className={classes.modalBody}>
                <div className={classes.contentWrapper}>
                    {ErrorMsg.CONNECTION_ERROR}
                </div>
                <div className={classes.modalActionWrapper}>
                    <Button
                        tabIndex={modalOpen ? 0 : -1}
                        onClick={closeModal}
                        id="close-button"
                        variant="contained"
                        color="primary"
                        className={classes.buttonStyle}
                    >
                        OK
                    </Button>
                </div>
            </div>])
        }
        else if (type === "alert" && ["string", "object"].includes(typeof modalOpen)) {
            style = modalOpen ? { bottom: 0 } : { bottom: -200 }
            return (<div id="alert-modal" style={style} className={classes.modalNoConnectionWrapper}>
                <div key="header" className={`${classes.modalHeader} ${classes.modalAlertHeader}`}>Error</div>
                <div key="body" className={classes.modalBody}>
                    <div className={classes.contentWrapper}>
                        {modalOpen}
                    </div>
                    <div className={classes.modalActionWrapper}>
                        <Button
                            tabIndex={modalOpen ? 0 : -1}
                            onClick={closeModal}
                            variant="contained"
                            id="close-button"
                            color="primary"
                            className={classes.buttonStyle}
                        >
                            OK
                    </Button>
                    </div>
                </div>
            </div>
            )
        }
        else if (type === "twilio" && typeof modalOpen === "string") {
            style = modalOpen ? { bottom: 0 } : { bottom: -200 }
            return (<div id="alert-modal" style={style} className={classes.modalNoConnectionWrapper}>
                <div key="header" className={`${classes.modalHeader} ${classes.modalAlertHeader}`}>Twilio Error</div>
                <div key="body" className={classes.modalBody}>
                    <div className={classes.contentWrapper}>
                        {modalOpen}
                    </div>
                    <div className={classes.modalActionWrapper}>
                        <Button
                            tabIndex={modalOpen ? 0 : -1}
                            onClick={closeModal}
                            id="close-button"
                            variant="contained"
                            color="primary"
                            className={classes.buttonStyle}
                        >
                            OK
                    </Button>
                    </div>
                </div>
            </div>
            )
        }
        return (
            <div style={style} className={classes.modalWrapper}>
                {children}
            </div>
        )
    }
}


export default withStyles(ModalExitAlertStyle)(ModalExitAlert);

